module.exports = __webpack_public_path__ + "static/img/rpc_error.a0f7a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rpc_error.png
// module id = 1460
// module chunks = 1